import Incoming from "@src/icons/Incoming";
import Invalid from "@src/icons/Invalid";
import Outgoing from "@src/icons/Outgoing";
import Warning from "@src/icons/Warning";
import { type ReactElement } from "react";

// LogMessage defined at api/src/common/enums/log-message.enum.ts
export type LogMessage =
    | "ReceivedSMS"
    | "SendSMS"
    | "FailedSMS"
    | "CommandInvalid"
    | "SendFailure"
    | "DailyReport"
    | "DeleteCamera"
    | "StartedMoveSim"
    | "FinishedMoveSim"
    | "VideoRequested"
    | "VideoRequestFailed"
    | "VideoReceived";

interface TypeProps {
    message: LogMessage;
}

export const Type = ({ message }: TypeProps): ReactElement | null => {
    switch (message) {
        case "FailedSMS":
        case "SendFailure":
        case "VideoRequestFailed":
            return <Warning />;
        case "CommandInvalid":
            return <Invalid />;
        case "ReceivedSMS":
        case "VideoReceived":
            return <Incoming />;
        case "SendSMS":
        case "VideoRequested":
            return <Outgoing />;
        default:
            return null;
    }
};
